var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "pageFrom",
                      attrs: {
                        inline: "",
                        size: "small",
                        model: _vm.pageFrom,
                        "label-position": "right",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "客户名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.pageFrom.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "name", $$v)
                                },
                                expression: "pageFrom.name",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.search },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "归属公司：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入选择",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.remoteMethod,
                                loading: _vm.searchLoading,
                                clearable: "",
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.companyId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "companyId", $$v)
                                },
                                expression: "pageFrom.companyId",
                              },
                            },
                            _vm._l(_vm.searchOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "合作状态：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.cooperationStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageFrom,
                                    "cooperationStatus",
                                    $$v
                                  )
                                },
                                expression: "pageFrom.cooperationStatus",
                              },
                            },
                            _vm._l(
                              _vm.cooperationStatusEnum,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "维护人：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择维护人",
                                filterable: "",
                                "filter-method": _vm.handleUserSearch,
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.maintainerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "maintainerId", $$v)
                                },
                                expression: "pageFrom.maintainerId",
                              },
                            },
                            _vm._l(_vm.userOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    "" +
                                    item.realName +
                                    (item.flag == 1 ? "（当前登陆人）" : ""),
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:coupon:customer:add"],
                          expression: "['admin:coupon:customer:add']",
                        },
                      ],
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.AddCoupon("ADD")
                        },
                      },
                    },
                    [_vm._v("新增客户")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:coupon:customer:batch-adjust-price"],
                          expression:
                            "['admin:coupon:customer:batch-adjust-price']",
                        },
                      ],
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.batchUpdate },
                    },
                    [_vm._v("批量改价")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.onSelectTab },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "名称", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyName",
                  label: "归属公司",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cooperationStatusDesc",
                  label: "合作状态",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ticketTypeDesc",
                  label: "票务类型",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "creditAmount",
                  label: "授信额度",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                directives: [
                  {
                    name: "has-permi",
                    rawName: "v-has-permi",
                    value: ["admin:customers:list:balance"],
                    expression: "['admin:customers:list:balance']",
                  },
                ],
                attrs: { prop: "balance", label: "余额", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                directives: [
                  {
                    name: "has-permi",
                    rawName: "v-has-permi",
                    value: ["admin:customers:list:frozenAmount"],
                    expression: "['admin:customers:list:frozenAmount']",
                  },
                ],
                attrs: {
                  prop: "frozenAmount",
                  label: "冻结金额",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "maintainer",
                  label: "维护人",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:coupon:customers:funds-records:list",
                                ],
                                expression:
                                  "['admin:coupon:customers:funds-records:list']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.CapitalAllocation(scope.row)
                              },
                            },
                          },
                          [_vm._v("资金记录")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:customer:dev-config"],
                                expression:
                                  "['admin:coupon:customer:dev-config']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.DevConfig(scope.row)
                              },
                            },
                          },
                          [_vm._v("开发配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:customer:product:list"],
                                expression:
                                  "['admin:coupon:customer:product:list']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.goProduct(scope.row)
                              },
                            },
                          },
                          [_vm._v("配置产品")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:customer:update"],
                                expression: "['admin:coupon:customer:update']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.AddCoupon(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:customer:delete"],
                                expression: "['admin:coupon:customer:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.DeleteRecode(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AddCouponVue", {
        ref: "AddCouponVueRef",
        attrs: { getList: _vm.getList },
      }),
      _vm._v(" "),
      _c("CapitalAllocationVue", { ref: "CapitalAllocationVueRef" }),
      _vm._v(" "),
      _c("DevConfigVue", { ref: "DevConfigVueRef" }),
      _vm._v(" "),
      _c("DeleteCouponVue", {
        ref: "DeleteCouponVueRef",
        attrs: { getList: _vm.getList },
      }),
      _vm._v(" "),
      _c("BatchUpdateVue", {
        ref: "BatchUpdateVueRef",
        on: { refresh: _vm.getList },
      }),
      _vm._v(" "),
      _c("ProductConfigVue", { ref: "ProductConfigVueRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }